export const DO_SEIBI = {
  suru: 1,
  shinai: 2,
  gojitsu: 3
};
// do, do not do, later date
